import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { updateFlag } from "../models/organizations";

export interface Organization {
    orgId: number,
    orgName: string
    
}

export interface CreateOrgPayload {
    orgName: string
}

@Injectable({
    providedIn: 'root'
})

export class OrganizationsService {
    sessionId: string = "";
    constructor(private http: HttpClient) { }

    search(payload: any = {}) {
        const user = sessionStorage.getItem('user');
        const userName = JSON.parse(user).username;
        this.sessionId = localStorage.getItem('sessionId');
        const url = `${environment.apiURL}/admin/organizations/search`;
        return this.http.post(url, payload,
            { headers: { 'cookie-header': `${this.sessionId}:${userName}` } }
        );
    }

    create(payload: any) {
        const user = sessionStorage.getItem('user');
        const userName = JSON.parse(user).username;
        this.sessionId = localStorage.getItem('sessionId');
        const url = `${environment.apiURL}/admin/organizations/create`;
        return this.http.post(url, payload,
            { headers: { 'cookie-header': `${this.sessionId}:${userName}` } });
    }

    update(payload: updateFlag) {
        const user = sessionStorage.getItem('user');
        const userName = JSON.parse(user).username;
        this.sessionId = localStorage.getItem('sessionId');
        const url = `${environment.apiURL}/admin/organizations/update`;
        return this.http.put(url, payload,
            { headers: { 'cookie-header': `${this.sessionId}:${userName}` } });
    }

    get(organizationId: any) {
        const user = sessionStorage.getItem('user');
        const userName = JSON.parse(user).username;
        this.sessionId = localStorage.getItem('sessionId');
        const url = `${environment.apiURL}/admin/organizations/get?organization_id=${organizationId}`;
        return this.http.get(url,
            { headers: { 'cookie-header': `${this.sessionId}:${userName}` } });
    }
}